// src/components/VenturesLinked.js — "Rainmaker Ventures" section for a
// contact or firm profile: every venture the record is linked to, with its
// role. The other half of the links on VentureDetail.js. Shows nothing when
// there are none.
import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import api from '../lib/api'

export default function VenturesLinked({ contactId, firmId, divider = false }) {
  const params = contactId ? { contact_id: contactId } : { firm_id: firmId }
  const { data } = useQuery({
    queryKey: ['ventures-linked', params],
    queryFn: () => api.get('/api/ventures', { params }).then(r => r.data.data ?? []),
  })
  if (!data?.length) return null

  return (
    <>
      {divider && <div className="divider" />}
      <div>
        <div style={{ fontSize: 12, fontWeight: 600, textTransform: 'uppercase',
          letterSpacing: '0.06em', color: 'var(--text-secondary)', marginBottom: 8 }}>
          Rainmaker Ventures
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {data.map(v => (
            <div key={v.venture_id} style={{ display: 'flex', gap: 8, alignItems: 'baseline', fontSize: 13, flexWrap: 'wrap' }}>
              <span className="badge badge-blue">{v.ref}</span>
              <Link to={`/ventures/${v.venture_id}`} style={{ color: 'var(--blue-text)', fontWeight: 500 }}>{v.name}</Link>
              {v.role && <span style={{ color: 'var(--text-muted)', fontSize: 12 }}>{v.role}</span>}
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
